import { render, staticRenderFns } from "./ListagemCompraHeader.vue?vue&type=template&id=b10665f4"
import script from "./ListagemCompraHeader.vue?vue&type=script&lang=js"
export * from "./ListagemCompraHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports